import styled from 'styled-components';
import { Select } from 'components/common';

export const ActionsHeader = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap-reverse;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 10px;
  flex: 1;
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const FiltersRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  flex-wrap: wrap;
  margin-right: -15px;
`;

export const FilterItem = styled.div`
  display: flex;
  margin-bottom: 15px;
  margin-right: 15px;
  flex: 1;
  max-width: 300px;
  min-width: 200px;
`;

export const DataEnrichmentSelect = styled(Select).attrs({
  style: { width: '100%' },
})``;

export const StatusPip = styled.div`
  display: flex;
  background: ${p => (p.background ? p.background : 'white')};
  color: ${p => (p.color ? p.color : 'white')};
  align-items: center;
  justify-content: center;
  border: none;
  width: 100px;
  height: 25px;
  border-radius: 2px;
`;
